import { getConfig } from '@hub/libs/hub-config';
import { useMemo } from 'react';
import Cookies from 'js-cookie';

/**
 * The "myigus" application sets a cookie after successful login at
 * https://www.igus.de/myigus/default.aspx?page=login
 *
 * Therefore, we are able to identify whether a user is a potential "myigus"
 * user or not.
 *
 * ATTENTION: we are currently not able to verify whether the user is really logged in,
 * the myigus-session cookie has expired or the user has set the cookie manually.
 */
export const isPotentialMyIgusUser = (): boolean => Cookies.get('isMyIgusAuthenticated') === 'true';

// Static list of locales that should use the new myigus login
const NEW_MYIGUS_LOGIN_LOCALES = ['en-GB'];

export function useNewMyIgus(locale: string): boolean {
  const locales = useMemo(() => {
    const config = getConfig<'newMyigusLocalesConfig'>('newMyigusLocalesConfig');
    return [...NEW_MYIGUS_LOGIN_LOCALES, ...new Set(config)];
  }, []);

  return locales.includes(locale) || locales.includes('all');
}
